import { operationType } from './../../tenders/enter-values-teners/enter-values-tenders.component';
import { Injectable } from '@angular/core'
import { CashierParms, ClaimsParms, HttpGeneralService, PatientParms } from '../../shared/shared';
import { CONFIG } from '../../shared/config';
import { BranchStp } from '../../hospitalSetup/gen_branches_stp/gen_branches_stp.service';
import { Clientmaindata } from '../../client/client-main-data-list/clientmaindata';
let CreateAndSignatureInvoiceZatcaUrl = CONFIG.baseUrls.CreateAndSignatureInvoiceZatca;
let electronicInvoiceUrl = CONFIG.baseUrls.electronicInvoiceUrl;


@Injectable({
  providedIn: 'root'
})
export class ElectroincInvoiceZatcaService {

  constructor(private httpGeneralService: HttpGeneralService) { }
  CreateXmlAndSignature(ModifiedElectronicInvoice: ElectroincInvoicData[]) {
    return this.httpGeneralService.addCollection(ModifiedElectronicInvoice, `${CreateAndSignatureInvoiceZatcaUrl}/CreateXmlAndSignature`);
  }
  GetMasterElctronicInvoice(PatientParms: PatientParms) {
    return this.httpGeneralService.add(PatientParms, `${CreateAndSignatureInvoiceZatcaUrl}/GetMasterElctronicInvoice`);
  }
  getSlsClientBillMasterElectroincInvoiceZatca(clientmaindata: Clientmaindata) {
    return this.httpGeneralService.add(clientmaindata, `${CreateAndSignatureInvoiceZatcaUrl}/GetSlsClientBillMasterElectroincInvoiceZatca`);
  }
  //---Nada---
  getAcrClaimMasterElectroincInvoiceZatca(claimsParms: ClaimsParms) {
    return this.httpGeneralService.add(claimsParms, `${CreateAndSignatureInvoiceZatcaUrl}/GetAcrClaimMasterElectroincInvoiceZatca`);
  }

  //---Nada---
  GetElctronicInvoiceDetail(id: number) {
    return this.httpGeneralService.get(id, `${CreateAndSignatureInvoiceZatcaUrl}/getInvoiceDetail/`);
  }
  getCreditNoteOutpatientElectroincInvoiceZatca(PatientParms: PatientParms) {
    return this.httpGeneralService.add(PatientParms, `${CreateAndSignatureInvoiceZatcaUrl}/GetCreditNoteOutpatientElectroincInvoiceZatca`);
  }

}
export interface ElectroincInvoicData {
  patCode?: number
  patNameAr: string
  transactionType: string
  patNameEn: string
  InvoiceType?: number
  TransactionType?: string
  identityValue: string
  contractId: number
  contractNameAr: string
  contractNameEn: string
  visitSerial: number
  branchId?: number
  reciptNo: number
  electronicInvoiceSerial: number
  reciptSerial: number
  price?: number
  netPrice?: number
  netPricePlusVat?: number
  patPrice?: number
  sharedPrice?: number
  patVat?: number
  vatValue?: number
  sharedVat?: number
  vatGovt?: number
  disVal?: number
  payedValue?: number
  govVat?: number
  transFlagNameAr: string
  nationalityId?: number,
  servOrItemAr: string
  servOrItemEn: string
  checked?: number
  type?: number;
  egBillSerial: string;
  reasonCancel: string;
  reasonReject: string;
  tableName: string;
  unitValueCurrencySold: string;
  unitValueAmountEGP: number;
  nphiesTotal?: number;
  unitValueAmountSold: number;
  unitValueCurrencyExchangeRate: number;
  purchaseOrderReference: string;
  purchaseOrderDescription: string;
  salesOrderReference: string;
  salesOrderDescription: string;
  proformaInvoiceNumber: string;
}
export interface ModifiedElectronicInvoice {
  ElectroincInvoicData: ElectroincInvoicData[];
  Branch: BranchStp;
}
